import React, { useEffect, useState } from "react";

export default function LoadingOverlay() {
  const [pending, setPending] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const handler = (e) => setPending(e.detail.pending);
    window.addEventListener("mw-loading", handler);
    return () => window.removeEventListener("mw-loading", handler);
  }, []);

  useEffect(() => {
    if (pending <= 0) {
      setSeconds(0);
      return;
    }
    const t = setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, [pending]);

  if (pending <= 0) return null;

  return (
    <div
      data-testid="loading-overlay"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-950/50 backdrop-blur-[2px]"
    >
      <div className="glass flex flex-col items-center gap-3 rounded-2xl border border-slate-700 px-8 py-6 shadow-2xl">
        <div className="h-10 w-10 rounded-full border-4 border-slate-600 border-t-blue-500 mw-spin" />
        <div className="text-sm font-semibold tracking-wide text-slate-100">İŞLEM YAPILIYOR...</div>
        {seconds >= 10 && (
          <div className="text-xs text-amber-400">
            VERİ İŞLENİYOR, LÜTFEN BEKLEYİN ({seconds} SN)
          </div>
        )}
      </div>
    </div>
  );
}
